type Threadable = { id: string; parent_id?: string | null; created_at: string };

/** Flatten legacy nested replies while keeping deleted parents and orphaned replies visible. */
export function commentThreads<T extends Threadable>(comments: T[]): { root: T; replies: T[] }[] {
  const ordered = [...comments].sort((a, b) => a.created_at.localeCompare(b.created_at) || a.id.localeCompare(b.id));
  const byId = new Map(ordered.map(comment => [comment.id, comment]));
  const groups = new Map<string, { root: T; replies: T[] }>();
  for (const comment of ordered) {
    let root = comment;
    const seen = new Set([root.id]);
    while (root.parent_id && byId.has(root.parent_id) && !seen.has(root.parent_id)) {
      root = byId.get(root.parent_id)!;
      seen.add(root.id);
    }
    const group = groups.get(root.id) ?? { root, replies: [] };
    if (comment.id !== root.id) group.replies.push(comment);
    groups.set(root.id, group);
  }
  return [...groups.values()].sort((a, b) => a.root.created_at.localeCompare(b.root.created_at) || a.root.id.localeCompare(b.root.id));
}
